import { take, fork, cancel } from 'redux-saga/effects';

import { executeRequest } from '../executeRequest';

/**
 * Saga that forks our saga wrapper and sets it up for cancellation
 * @param {Object} $0 Action
 * @param {Object} $0.payload Action payload
 * @param {sagaConfig} $0.payload.sagaConfig Saga wrapper configuration
 */
export const handleRequest = function* ({ payload }) {
  const request = yield fork(executeRequest, { payload });

  if (payload?.sagaConfig?.cancelAction) {
    yield take(payload.sagaConfig.cancelAction.type);
    yield cancel(request);
  }
};
